/**
 * Odeslání data layer do GTM po kliknutí na tlačítko.
 * Stačí přidat na element data-data-layer-on-click='{ "event": "abc", "param": "yxz"}'
 * Po kliknutí dojde k zastavení eventu, odeslání to GTM a po timeoutu ke znovu kliknutí na tlačítko,
 * poté už probíhá normální chování.
 *
 * Pokud by byl problém s tím, že nedochází k odeslání dat, tak bude potřeba toto zrušit a přesunout datalayer vždy na výslednou stránku
 * Takto to poradil ChatGPT, mělo by to fungovat, ale někdy by se mohlo stát, že nedojde k odeslání protože se dříve odejde z aktuální stránky.
 */

export default function () {
	document.querySelectorAll('[data-data-layer-on-click]').forEach((button) => {
		button.addEventListener('click', (e) => {
			if (button.dataset.submittedToGTM === 'true') {
				return;
			}

			if (
				e.currentTarget.tagName === 'BUTTON' &&
				e.currentTarget.form &&
				e.currentTarget.getAttribute('formnovalidate') === null &&
				!Nette.validateForm(e.currentTarget.form, true)
			) {
				// Pokud jde o odeslání formuláře, musí být validní, aby došlo k odeslání do GTM,
				// validní nemusí být pokud má button formnovalidate atribut
				// pokud validní není, zde končíme
				return;
			}

			e.preventDefault();
			e.stopImmediatePropagation();
			e.stopPropagation();

			const clickEvent = new MouseEvent('click', {
				bubbles: true,
				cancelable: true
			});

			try {
				button.dataset.submittedToGTM = true;
				let data = JSON.parse(button.dataset.dataLayerOnClick);

				window.dataLayer.push(data);
			} catch (e) {
				button.dispatchEvent(clickEvent);
				return;
			}

			setTimeout(() => {
				button.dispatchEvent(clickEvent);
			}, 500);
		});
	});
}
